import { useNavigate } from 'react-router-dom';
import { XCircle } from '@phosphor-icons/react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-6">
      <div className="border border-zinc-800 rounded-xl bg-zinc-900/60 p-10 max-w-md w-full text-center">
        <XCircle size={48} className="text-zinc-500 mx-auto mb-4" />
        <h1 className="font-display text-2xl">Checkout canceled</h1>
        <p className="text-sm text-zinc-400 mt-2">No charge was made. You can grab credits any time.</p>
        <button data-testid="back-to-credits-cancel" onClick={() => navigate('/credits')} className="mt-6 btn-neon px-5 py-2 rounded-full font-display font-semibold">Back to Credits</button>
      </div>
    </div>
  );
}
